<div class="row" style="margin-top:20px;">
  <mat-form-field (mouseenter)="hint='Model_Type'">
    <mat-label>Model Type</mat-label>
    <mat-select [(ngModel)]="config.model_type" name="model_types">
      @for (model_type of model_types; track model_type) {
        <mat-option [value]="model_type">
          {{model_type| upperfirst}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
@if (config.model_type) {
  <div class="row">
    @if (config?.component_list && ['series','process'].includes(config.model_type)) {
      <div (mouseenter)="hint='Process'" class="select-search" style="margin-right:0;">
        <select-many-search-component
          [api_model]="'process_light'"
          [value]="config.component_list"
          [classes]="'fill'"
          (selectionChange)="processChange($event)"
          [label]="'Select a process'">
        </select-many-search-component>
      </div>
    }
    @if (['series'].includes(config.model_type)) {
      <div
        style="align-self: center;font-weight: bold;padding:0 10px; justify-self: center;">and/or
      </div>
    }
    @if (config?.series_list && ['series'].includes(config.model_type)) {
      <div (mouseenter)="hint='Series'" class="select-search" style="position:relative;">
        <select-many-series
          [value]="config.series_list"
          [classes]="'fill'"
          (selectionChange)="seriesChange($event)"
        ></select-many-series>
      </div>
    }
  </div>
}
